import React, { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import AdminPet from './Admin/Pet';
import PetOwnerPet from './Pet Owner/Pet';
import { ROLES } from '../config/constants';

const Pet = () => {
    const { user, roles } = useContext(UserContext);

    if (roles.includes(ROLES.ADMIN)) {
        return <AdminPet user={user} roles={roles} />;
    } else if (roles.includes(ROLES.USER)) {
        return <PetOwnerPet user={user} roles={roles} />;
    } else {
        return <></>
    }
};

export default Pet;
